import { Outlet, ScrollRestoration, useLocation } from "react-router-dom"
import Footer from "./Footer"
import SiteHeader from "./SiteHeader"
import { Toaster } from "./ui/toaster"
import { OfflineBanner } from "./offline-banner"
import { UpdateBanner } from "./update-banner"
import { InstallBanner } from "./install-banner"
import { MobileNav } from "./mobile-nav"
import { useAuthSession } from "@/hooks/use-auth-session"
import { cn } from "@/lib/utils"
import type { NavSurface } from "./nav-config"

export const DESIGN_MARKETING_PATHS = ["/", "/tap-in", "/roadmap", "/ecosystem"] as const
const MARKETING_SUB_ROUTES = ["/tap-in", "/roadmap", "/ecosystem"] as const

export default function Layout() {
  const { pathname } = useLocation()
  const { isAuthenticated } = useAuthSession()
  const isMarketingSubRoute = MARKETING_SUB_ROUTES.includes(
    pathname as (typeof MARKETING_SUB_ROUTES)[number],
  )
  // Guest marketing surfaces only — logged-in users keep app chrome everywhere.
  const isGuestMarketing =
    !isAuthenticated && (pathname === "/" || isMarketingSubRoute)
  const headerVariant: NavSurface = isGuestMarketing ? "marketing" : "app"
  const showMobileNav = !isGuestMarketing
  const showAppFooter = !isGuestMarketing

  return (
    <div
      className={cn(
        "min-h-screen",
        isGuestMarketing
          ? "landing-page bg-white text-foreground"
          : "bg-background text-foreground",
      )}
    >
      <ScrollRestoration />
      <OfflineBanner />
      <UpdateBanner />
      <SiteHeader variant={headerVariant} />
      <Toaster />
      <main
        className={
          isGuestMarketing
            ? "w-full max-w-none flex-1 min-w-0 overflow-x-hidden p-0"
            : "mx-auto w-full max-w-[1920px] flex-1 min-w-0 overflow-x-hidden px-3 pt-3 pb-[calc(4.5rem+env(safe-area-inset-bottom,0px))] sm:px-4 sm:pt-4 md:p-8 md:pb-0 lg:p-10"
        }
      >
        <div className={isGuestMarketing ? undefined : "animate-in fade-in duration-500 slide-in-from-bottom-2"}>
          <Outlet />
        </div>
      </main>
      {showAppFooter && (
        <div className="hidden md:block">
          <Footer />
        </div>
      )}
      {showMobileNav && <MobileNav />}
      <InstallBanner />
    </div>
  )
}
